import { useState, useRef } from "react";
import {
  Typography, Grid, Card, CardContent, CardMedia, Button,
  Chip, IconButton, Box, Avatar, Link
} from "@mui/material";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import StarIcon from "@mui/icons-material/Star";
import FavoriteIcon from "@mui/icons-material/Favorite";
import PropTypes from "prop-types";
import { Link as RouterLink } from "react-router-dom";

// Swiper imports
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

const SectionService = ({
  services,
  title,
  subtitle,
  showAvailability = false,
  showPriece = false,
  favoriteService,
  irA,
  onVerDetalle,
}) => {
  const [prevEl, setPrevEl] = useState(null);
  const [nextEl, setNextEl] = useState(null);

  return (
    <Box sx={{ position: "relative", mt: 4 }}>
      <Grid container spacing={2} sx={{ mb: 3 }}>
        <Grid size={{ xs: 12, md: 6 }} sx={{ alignItems: "stretch" }}>
          <Typography variant="h6" color="primary">
            {title}
          </Typography>
          <Typography variant="body1" color="#737791">
            {subtitle}
          </Typography>
        </Grid>
      </Grid>

      <Box sx={{ position: "relative" }}>
        <Swiper
          modules={[Navigation, Pagination]}
          spaceBetween={16}
          slidesPerView={1}
          navigation={{
            prevEl,
            nextEl,
          }}
          breakpoints={{
            640: {
              slidesPerView: 2,
            },
            900: {
              slidesPerView: 3,
            },
            1200: {
              slidesPerView: 4,
            },
          }}
          style={{ paddingBottom: '10px' }}
        >
          {services.map((srv, index) => (
            <SwiperSlide key={index} style={{ height: 'auto' }}>
              <Card
                sx={{
                  borderRadius: 3,
                  boxShadow: 2,
                  position: "relative",
                  height: "100%",
                  display: 'flex',
                  flexDirection: 'column',
                  overflow: 'hidden'
                }}
              >
                <CardMedia
                  component="img"
                  height="180"
                  image={srv.image && srv.image !== ""
                    ? srv.image
                    : "/search.png"
                  }
                  alt={srv.title}
                  onClick={() => onVerDetalle && onVerDetalle(srv)}
                  sx={{ cursor: 'pointer' }}
                />
                {/* El degradado no debe interceptar el clic para que la foto lleve a detalles */}
                <Box className="transp" sx={{ height: 180, position: 'absolute', width: '100%', top: 0, left: 0, pointerEvents: 'none', background: 'linear-gradient(to bottom, rgba(0,0,0,0) 0%, rgba(0,0,0,0.4) 100%)' }} />
                <IconButton
                  sx={{
                    position: "absolute",
                    top: 8,
                    right: 8,
                    color: srv.favorite ? "#234095" : "white",
                    p: 0.5,
                    bgcolor: srv.favorite ? "rgba(255,255,255,0.9)" : "transparent",
                    '&:hover': { bgcolor: srv.favorite ? "white" : "rgba(255,255,255,0.2)" }
                  }}
                  onClick={() => favoriteService(srv)}
                >
                  {srv.favorite
                    ? <FavoriteIcon sx={{ fontSize: 20 }} />
                    : <FavoriteBorderIcon sx={{ fontSize: 20 }} />
                  }
                </IconButton>
                <Chip
                  label={srv.category}
                  color="primary"
                  size="small"
                  sx={{ position: "absolute", top: 10, left: 10, height: 20, fontSize: '0.65rem' }}
                />
                <Link
                  component={RouterLink}
                  to={`/perfil/${srv.userId}`}
                  underline="none"
                  className="author_info"
                  sx={{
                    position: 'absolute',
                    top: 140,
                    left: 10,
                    display: 'flex',
                    alignItems: 'center',
                    cursor: 'pointer',
                    zIndex: 2,
                    '&:hover': {
                      opacity: 0.8
                    }
                  }}
                >
                  <Avatar
                    alt={srv.author}
                    src={srv.authorAvatar || "/broken-image.jpg"}
                    sx={{ bgcolor: "primary", width: 30, height: 30, marginRight: 1 }}
                  />
                  <Typography variant="caption" fontWeight="bold" color="#FFF">
                    {srv.author}
                  </Typography>
                </Link>
                <CardContent sx={{ p: 1.5, flexGrow: 1, display: 'flex', flexDirection: 'column', "&:last-child": { pb: 1.5 } }}>
                  <Grid container spacing={1} sx={{ mb: 1 }}>
                    <Grid item size={{ xs: 9 }}>
                      <Typography variant="subtitle2" fontWeight="bold" color="primary" noWrap>
                        {srv.title}
                      </Typography>
                    </Grid>
                    <Grid item size={{ xs: 3 }} sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                      {srv.rating && srv.rating !== "" &&
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                          <StarIcon sx={{ fontSize: 14, color: '#fbc02d', mr: 0.2 }} />
                          <Typography variant="caption" fontWeight="bold">{srv.rating}</Typography>
                        </Box>
                      }
                    </Grid>
                  </Grid>

                  <Typography variant="caption" color="#737791" sx={{
                    display: '-webkit-box',
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: 'vertical',
                    overflow: 'hidden',
                    lineHeight: 1.2,
                    mb: 1
                  }}>
                    {srv.description}
                  </Typography>

                  <Box sx={{ mb: 1 }}>
                    <Typography variant="caption" fontWeight="bold" color="#737791" display="block">
                      {srv.author}
                    </Typography>
                    {srv.location && srv.location.trim() !== "" && (
                      <Box sx={{ display: "flex", alignItems: "center", mt: 0.2 }}>
                        <LocationOnIcon color="primary" sx={{ fontSize: 14, mr: 0.2 }} />
                        <Typography variant="caption" color="primary" noWrap>
                          {srv.location}
                        </Typography>
                      </Box>
                    )}
                    {srv.duration && srv.duration !== "" &&
                      <Box sx={{ display: "flex", alignItems: "center", mt: 0.2 }}>
                        <AccessTimeIcon sx={{ fontSize: 14, mr: 0.2, color: 'primary.main' }} />
                        <Typography variant="caption" color="primary">{srv.duration}</Typography>
                      </Box>
                    }
                  </Box>

                  <Box sx={{ mt: 'auto', pt: 1, display: 'flex', alignItems: 'flex-end', justifyContent: 'space-between' }}>
                    <Box>
                      {showAvailability &&
                        <Typography variant="caption" color="#737791" sx={{ display: 'block', lineHeight: 1 }}>
                          <strong>10</strong> Disponibles
                        </Typography>
                      }
                      {showPriece &&
                        <Box>
                          <Typography variant="subtitle1" color="primary" fontWeight="bold" sx={{ lineHeight: 1 }}>
                            ${srv.price}.00
                          </Typography>
                          <Typography variant="caption" color="#737791">por {srv.tipoCosto && srv.tipoCosto.toLowerCase()}</Typography>
                        </Box>
                      }
                    </Box>
                    <Button
                      variant="contained"
                      size="small"
                      onClick={() => onVerDetalle && onVerDetalle(srv)}
                      sx={{
                        px: 1,
                        py: 0.5,
                        fontSize: "0.75rem",
                        textTransform: "none",
                        borderRadius: 2,
                        minWidth: 'auto'
                      }}
                    >
                      Ver detalle
                    </Button>
                  </Box>
                </CardContent>
              </Card>
            </SwiperSlide>
          ))}
        </Swiper>

        <IconButton
          ref={(node) => setPrevEl(node)}
          className="swiper-nav-button"
          sx={{
            position: "absolute",
            top: "50%",
            left: 5,
            transform: "translateY(-50%)",
            bgcolor: "rgba(255, 255, 255, 0.8)",
            boxShadow: 2,
            zIndex: 10,
            width: 32,
            height: 32,
            "&:hover": { bgcolor: "white" },
            "&.swiper-button-disabled": { display: 'none' }
          }}
        >
          <ArrowBackIosNewIcon sx={{ fontSize: 18 }} />
        </IconButton>

        <IconButton
          ref={(node) => setNextEl(node)}
          className="swiper-nav-button"
          sx={{
            position: "absolute",
            top: "50%",
            right: 5,
            transform: "translateY(-50%)",
            bgcolor: "rgba(255, 255, 255, 0.8)",
            boxShadow: 2,
            zIndex: 10,
            width: 32,
            height: 32,
            "&:hover": { bgcolor: "white" },
            "&.swiper-button-disabled": { display: 'none' }
          }}
        >
          <ArrowForwardIosIcon sx={{ fontSize: 18 }} />
        </IconButton>
      </Box>
    </Box>
  );
};

SectionService.propTypes = {
  favoriteService: PropTypes.func.isRequired,
  irA: PropTypes.func.isRequired,
}

export default SectionService;
